<template>
  <div>
    <h1>{{ $t('errors.unauthorized') }}</h1>
    <p>{{ $t('errors.unauthorized_message') }}</p>
  </div>
</template>

<script setup lang="ts">
// Shown when admin lacks required role/permission
// Template uses $t() from the vue-i18n plugin directly
</script>
